module.exports = {"development":{"DEFAULT_ROOT":"https://widget-esf-testing.valraiso.net","CM_ROOT":"https://club-med.uat.esf-plus.com"},"testing":{"DEFAULT_ROOT":"https://widget-esf-testing.valraiso.net","CM_ROOT":"https://club-med.uat.esf-plus.com"},"integration":{"DEFAULT_ROOT":"https://widget-integration.vente-en-ligne-esf.com","CM_ROOT":"https://club-med-integration.esf-plus.com"},"uat":{"DEFAULT_ROOT":"https://widget-uat.vente-en-ligne-esf.com","CM_ROOT":"https://club-med-uat.esf-plus.com"},"production":{"DEFAULT_ROOT":"https://widget.vente-en-ligne-esf.com","CM_ROOT":"https://club-med.esf-plus.com"}}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 56
// module chunks = 0